import apiClient from "./axiosConfig";

export const getUserDetails = (id) => apiClient.get(`/users/details/admin/${id}`);

export const updateUserDetails = (id, data) => apiClient.put(`/users/admin/update/${id}/`, data);

export const changePassword = (data) => apiClient.post('/users/change-password/', data);

